import React from 'react';
import { SearchFilters, SortValue, SortDirection, SearchType } from '../../../../types/search';
import { Checkbox } from '../../../common/Checkbox';
import { FILTER_OPTIONS } from '../../../../constants/search';
import { getSortOptions } from '../../../../config/filter.config';

interface SortSectionProps {
  contentType: SearchType;
  draftFilters: SearchFilters;
  onSortChange: (sort: SortValue) => void;
  onSortOrderChange: (order: SortDirection) => void;
  t: (key: string) => string;
}

export const SortSection: React.FC<SortSectionProps> = ({
  contentType,
  draftFilters,
  onSortChange,
  onSortOrderChange,
  t
}) => {
  const availableSortOptions = getSortOptions(contentType);

  return (
    <div>
      {FILTER_OPTIONS.SORT
        .filter(option => availableSortOptions.includes(option.value))
        .map((option) => (
          <Checkbox
            key={option.value}
            checked={draftFilters.sortBy === option.value}
            label={t(option.translationKey)}
            onClick={() => onSortChange(option.value)}
            truncate={false}
          />
        ))}
    </div>
  );
}; 